import { FunctionComponent } from 'react';

// Components
import QRCode from 'qrcode.react';
import Image from '@Components/Utils/Image';
import Anchor from '@Components/Utils/Anchor';
import styles from './DoctorInfo.module.scss';
import AvatarStar from '@Components/UI/AvatarStar';

// Utilities
import classnames from 'classnames';

// Contexts
import { getAttachmentAvatar } from '@Libs/utils';
import { useDataTransfer } from '@Components/Utils/DataTransfer';
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import ButtonAdvisory from '../ButtonAdvisory';

interface DoctorInfoProps {
    className?: string;
}

const DoctorInfo: FunctionComponent<DoctorInfoProps> = (props) => {
    const { doctor } = useDataTransfer();
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const doctorName = doctor?.profile?.fullName || '';
    const { profile } = doctor || {};
    const lengthName = doctorName.length;

    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    return (
        <div className={className}>
            <div className={styles.body}>
                <ViewMedia is="desktop">
                    <ButtonAdvisory hasButton={false} className={styles.btn_advisory} />
                </ViewMedia>

                <div className={styles.info_wrapper}>
                    <AvatarStar
                        avatar={getAttachmentAvatar(doctor?.id, 'doctor')}
                        average={doctor?.profile?.rating?.average}
                        className={styles.avatar_wrapper}
                        avatarClassName={styles.avatar}
                        startWrapperClassName={styles.star_wrapper}
                        startIconClassName={styles.icon_star}
                    />

                    <div className={styles.info_item}>
                        <span className={styles.name}>{doctor?.profile?.fullName}</span>
                        <span className={styles.title}>
                            <Image className={styles.icon_medal} src="/assets/tra-cuu/bac-si/medal_icon.png" />
                            {doctor?.profile?.title}
                        </span>
                        <div className={styles.review_wrapper}>
                            <div className={styles.review_item}>
                                <span className={styles.review_number}>{numberWithCommas(profile?.rating?.count)}</span>
                                Lượt đánh giá
                            </div>
                            <div className={styles.review_item}>
                                <span className={styles.review_number}>{numberWithCommas(profile?.stats?.questions?.thanksCount)}</span>
                                Lượt cảm ơn
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.download_app_wrapper}>
                    <div className={styles.download_app}>
                        <div className={styles.title}>
                            Nhận tư vấn từ <strong>Bác sĩ {doctorName.slice(doctorName.lastIndexOf(' ') + 1, lengthName)}</strong> <br /> tại ứng dụng <strong>eDoctor</strong>. Tải ngay!
                        </div>
                        <div className={styles.download_app_items}>
                            <Anchor href="https://apps.apple.com/vn/app/edoctor-know-your-health/id1041327503" className={styles.app_item} tracking={{ action: 'user_click_download' }}>
                                <Image alt="eDoctor - App Store" src="/assets/tra-cuu/bac-si/app_store.png" />
                            </Anchor>

                            <Anchor href="https://play.google.com/store/apps/details?id=vn.edoctor.userapp" className={styles.app_item} tracking={{ action: 'user_click_download' }}>
                                <Image alt="eDoctor -  Google Play" src="/assets/tra-cuu/bac-si/google_play.png" />
                            </Anchor>
                        </div>
                    </div>
                </div>

                <div className={styles.footer_info}>
                    <div className={styles.highlight}>
                        <div className={styles.highlight_item}>
                            <Image src="/assets/tra-cuu/bac-si/checked_icon.png" />
                            <span className={styles.text}>Chat trực tiếp 30 phút</span>
                        </div>
                        <div className={styles.highlight_item}>
                            <Image src="/assets/tra-cuu/bac-si/checked_icon.png" />
                            <span className={styles.text}>Thực hiện đơn giản</span>
                        </div>
                        <div className={styles.highlight_item}>
                            <Image src="/assets/tra-cuu/bac-si/checked_icon.png" />
                            <span className={styles.text}>Không cần chờ đợi</span>
                        </div>
                    </div>
                    <div className={styles.qr}>
                        <QRCode className={styles.img} value={`https://dl.edoctor.io/doctor?id=${doctor?.id}`} id="canvas" />
                    </div>
                </div>
            </div>
        </div>
    );
};

DoctorInfo.defaultProps = {
    className: '',
};

export default DoctorInfo;
